import { resetSwConfigReady } from 'services/serviceWorker/swConfigReady';

const LOGOUT_FLOW_STALE_RESET_MS = 15_000;
let logoutFlowStartedAt: number | null = null;

export function markLogoutFlowStarted(): void {
  logoutFlowStartedAt = Date.now();
  resetSwConfigReady();
}

export function markLogoutFlowCompleted(): void {
  logoutFlowStartedAt = null;
}

export function isLogoutFlowInProgress(): boolean {
  if (logoutFlowStartedAt == null) {
    return false;
  }

  return Date.now() - logoutFlowStartedAt <= LOGOUT_FLOW_STALE_RESET_MS;
}

/** Wraps a handler of the worker's notices: skipped while this tab signs out (its data is dropped on purpose). */
export function runUnlessSigningOut(handler: () => void): () => void {
  return (): void => {
    clearStaleLogoutFlow();
    if (!isLogoutFlowInProgress()) {
      handler();
    }
  };
}

export function clearStaleLogoutFlow(): void {
  if (logoutFlowStartedAt !== null && !isLogoutFlowInProgress()) {
    logoutFlowStartedAt = null;
  }
}
